var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClockArrowUp = function SvgClockArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340-180q-125 0-212.5-87.5T40-480t87.5-212.5T340-780t212.5 87.5T640-480t-87.5 212.5T340-180m400 20v-488l-44 44-56-56 140-140 140 140-57 56-43-43v487zM340-260q92 0 156-64t64-156-64-156-156-64-156 64-64 156 64 156 156 64m80-80 56-56-96-97v-147h-80v180zm-80-140"
  })));
};
export default SvgClockArrowUp;